<template>
	<b-dropdown
		v-loading="isProcessing"
		toggle-class="bg-white rounded-pill border"
		text="Reports"
		menu-class="p-0"
		class="saved-reports-dropdown"
	>
		<template v-if="exportsOptions.length">
			<b-dropdown-item
				v-for="exportsOption in exportsOptions"
				:key="`filter-${exportsOption.value}`"
				link-class="p-0 d-flex align-items-center"
				href
			>
				<span
					@click="exportTemplate(exportsOption.value)"
					class="w-100 p-3"
					>{{ exportsOption.label }}</span
				>

				<b-link
					@click.prevent.stop="editTemplate(exportsOption.value)"
					class="text-primary py-3 pl-3 pr-2 ml-auto"
				>
					<b-icon icon="pencil" font-scale="0.875"></b-icon>
				</b-link>
				<b-link
					@click.prevent.stop="deleteTemplate(exportsOption.value)"
					class="py-3 pr-3 pl-2 text-danger"
				>
					<b-icon icon="trash" font-scale="0.875"></b-icon>
				</b-link>
			</b-dropdown-item>
		</template>
		<b-dropdown-text v-else>No items found.</b-dropdown-text>
	</b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { ExportsService, ReportsService } from "@services";

export default {
	data() {
		return {
			isProcessing: false,
		};
	},
	computed: {
		...mapGetters(["exportsList"]),
		exportsOptions() {
			return this.exportsList.map((item) => ({
				value: item.id,
				label: item.name,
			}));
		},
	},
	methods: {
		async exportTemplate(id) {
			const idx = this.exportsList.findIndex((item) => item.id === id);

			if (0 > idx) return false;

			const payload =
				"string" == typeof this.exportsList[idx].payload
					? JSON.parse(this.exportsList[idx].payload)
					: this.exportsList[idx].payload;

			this.isProcessing = true;

			await ReportsService.exportData(payload);

			this.isProcessing = false;

			this.$toasted.show(
				"Your export is in progress. You will be emailed when it's ready on the Export Log page."
			);
		},
		async editTemplate(id) {
			await ExportsService.getExport(id);

			this.$emit("edit", id);
		},
		async deleteTemplate(id) {
			await ExportsService.deleteExport(id);

			this.$toasted.show("Saved export deleted.");
		},
	},
	mounted() {
		ExportsService.getExports();

		this.$bus.$on("error-catched", () => {
			this.isProcessing = false;
		});
	},
};
</script>

<style lang="scss">
.saved-reports-dropdown {
	.dropdown-toggle {
		border-color: #e59616 !important;
	}

	.dropdown-item a {
		line-height: 0.75;
	}
}
</style>
